export default "__VITE_ASSET__DPlMkGcA__"